// extracted by mini-css-extract-plugin
export default {"innerWrapper":"tx-z","tooltipWrapper":"ux-z","icon":"vx-z","tooltip":"wx-z","content":"xx-z"};